import PropTypes from 'prop-types'
import React, { Component, Suspense } from 'react'
import { BrowserRouter, Route, Routes, redirect, Navigate } from 'react-router-dom'
import toast, { Toaster } from "react-hot-toast";
import { connect } from 'react-redux'
import './scss/style.scss'
var _ = require('lodash');

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
/*const Register = React.lazy(() => import('./views/pages/register/Register'))*/
const ForgotPassword = React.lazy(() => import('./views/pages/login/ForgotPassword'));
const ResetPassword = React.lazy(() => import('./views/pages/login/ResetPassword'));
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))

class App extends Component {
  render() {
    return (
      <>
        <BrowserRouter>
          <Suspense fallback={loading}>
            <Routes>
              <Route path="/login" name="Login Page" element={
                _.isEmpty(this.props.token) ?
                  <Login />
                  :
                  <Navigate to="/" />
              } />
              <Route exact path="/forgotpassword" name="Forgot Password" element={<ForgotPassword />} />
              <Route exact path="/ResetPassword" name="Reset Password" element={<ResetPassword />} />
              {/*<Route exact path="/register" name="Register Page" element={<Register />} />*/}
              
             {/* <Route exact path="/500" name="Page 500" element={<Page500 />} />*/}
              <Route path="*" name="Home" element={<DefaultLayout />} />
              {/*<Route exact path="/404" name="Page 404" element={<Page404 />} />*/}
            </Routes>
          </Suspense>
        </BrowserRouter>
        <Toaster position="bottom-center" reverseOrder={false} />
      </>
    )
  }
}

App.propTypes = {
  loginUser: PropTypes.object,
  token: PropTypes.string,
};
const mapStateToProps = state => ({
  loginUser: state.loginUser,
  token: state.token.token
});

export default connect(mapStateToProps)(App);
